'use client';

import { SessionProvider } from 'next-auth/react';
import { AuthContextProvider } from '@/providers/auth-context';
import { MobileAppProvider } from '@/providers/mobile-app-context';

export default function MobilePreviewShell({ children }) {
    return (
        <SessionProvider>
            <AuthContextProvider>
                <MobileAppProvider>
                    <div className='main mobile-shell'>
                        {children}
                    </div>
                </MobileAppProvider>
            </AuthContextProvider>
        </SessionProvider>
    );
}
